module.exports = __webpack_public_path__ + "img/badge-ad-fill.207da189.svg";